import React from 'react';

interface ContactUsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ContactUsModal: React.FC<ContactUsModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/70 z-[60] flex items-center justify-center p-4" onClick={onClose}>
      <div 
        className="bg-navy-blue p-8 rounded-lg shadow-2xl w-full max-w-lg relative text-light-blue" 
        onClick={(e) => e.stopPropagation()}
      >
        <button onClick={onClose} className="absolute top-4 right-4 text-light-blue hover:text-off-white text-3xl font-light z-10">&times;</button>
        
        <div>
          <h2 className="text-3xl font-bold mb-4 text-off-white">Contact Us</h2>
          
          <p className="mt-4 mb-6">
            We'd love to hear from you! Whether you have a question, feedback, or a suggestion for a new feature, please don't hesitate to get in touch.
          </p>

          <div className="bg-dark-blue p-4 rounded-lg text-center">
            <p className="text-base text-light-blue mb-2">The best way to reach us is by email:</p>
            <a 
              href="mailto:fulminetto14@gmail.com" 
              className="text-lg font-bold text-btc-orange hover:text-orange-400 transition-colors duration-300 break-all"
            >
              fulminetto14@gmail.com
            </a>
          </div>
          
          <p className="mt-6 text-sm text-steel-blue">
            We do our best to respond to all inquiries as quickly as possible.
          </p>
        </div>
        
        <div className="text-right mt-8 pt-4 border-t border-steel-blue">
            <button
              onClick={onClose}
              className="px-6 py-2 rounded-lg bg-btc-orange text-dark-blue hover:bg-orange-400 transition-colors font-semibold"
            >
              Close
            </button>
        </div>
      </div>
    </div>
  );
};

export default ContactUsModal;